import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import Page from '../../components/Page';
import PageHeader from '../../components/PageHeader';
// import CourseBucket from './CourseBucket';
import CourseBucket, { CourseBucketSkeleton } from './CourseBucketV2';
import moment from 'moment';
import Button from '../../components/Stuff/Button';
import Meta from '../../components/Meta';
import Http from '../../constants/Http';
import { Collapse } from 'reactstrap';
import { Grid } from '@builtbypixel/plasma';
import dayjs from 'dayjs';
import { getCourses } from '../../modules/courses';

import './Home.scss';
import Bubble from '../../components/Bubble';

import isBetween from 'dayjs/plugin/isBetween';
import QandAHomepage from '../../components/QandAHomepage';
import ContactForm from '../../components/ContactForm';
dayjs.extend(isBetween);

const showDiscount = () => {
  if (dayjs().isBetween('2023-11-13', dayjs('2023-12-21'))) {
    return true;
  } else {
    return false;
  }
};

const CATEGORY_BUCKET_SLUGS = [
  'management-leadership',
  'coaching-mentoring',
  'professional-management',
  'professional-consultancy',
  'project-management'
];

const PRICE_TIERS = ['award', 'certificate', 'diploma', 'extended_diploma', 'other'];

const getCategoryMinPrice = courses => {
  const totals = [];
  courses.forEach(course => {
    PRICE_TIERS.forEach(tier => {
      if (Array.isArray(course[tier])) {
        course[tier].forEach(t => {
          const price = parseFloat(t.price);
          const regFee = parseFloat(t.reg_fee) || 0;
          if (!isNaN(price) && price > 0) totals.push(price + regFee);
        });
      }
    });
  });
  return totals.length ? Math.min(...totals) : null;
};

const Home = ({ courses, dispatch, ...props }) => {
  const [seoCourses, setSeoCourses] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [accordionIsOpen, setAccordionIsOpen] = useState(false);
  const [categoryMinPrices, setCategoryMinPrices] = useState({});
  const [pricesLoaded, setPricesLoaded] = useState(false);

  useEffect(() => {
    getSEOCourseData();
    dispatch(getCourses());
    fetchCategoryMinPrices();
  }, [dispatch]);

  const toggleAccordion = () => {
    setAccordionIsOpen(prev => !prev);
  };

  const getSEOCourseData = () => {
    setIsLoading(true);
    Http.get(`/seo-links`)
      .then(res => {
        setSeoCourses(res.data.data);
        setIsLoading(false);
      })
      .catch(err => {
        setIsLoading(false);
        console.error(err);
      });
  };

  const fetchCategoryMinPrices = () => {
    Promise.all(
      CATEGORY_BUCKET_SLUGS.map(async slug => {
        try {
          const res = await Http.get(`/courses/${slug}`);
          const courses = res.data.data || [];
          let minPrice = getCategoryMinPrice(courses);

          // The category listing endpoint omits the `other` price array,
          // so when it yields no prices, fall back to per-course detail
          // calls which do include `other`.
          if (minPrice == null && courses.length > 0) {
            const details = await Promise.all(
              courses.map(c =>
                Http.get(`/course/${c.slug}`)
                  .then(r => r.data.data)
                  .catch(() => null)
              )
            );
            minPrice = getCategoryMinPrice(details.filter(d => d != null));
          }

          return { slug, minPrice };
        } catch (e) {
          return { slug, minPrice: null };
        }
      })
    ).then(results => {
      const map = {};
      results.forEach(r => {
        if (r.minPrice != null) map[r.slug] = r.minPrice;
      });
      setCategoryMinPrices(map);
      setPricesLoaded(true);
    });
  };

  return (
    <Page classnames="homepage">
      <Meta
        type={'website'}
        title="Business Courses Online | Distance Learning Business & Management Courses | UK"
        description="Brighten Your Future With Online Distance Learning Courses at Brighton School of Business and Management. To apply or to find out more about our online distance learning courses, including degrees, browse our website or complete our online enquiry form to request further information."
      />
      <PageHeader isHomePage>
        {showDiscount() && (
          <p>
            Quote <strong>Winter23</strong> to receive 10% off course fees for
            enrolments completed before 21st December 2023
          </p>
        )}
        <div className={'d-none d-lg-inline'}>
          <Bubble
            speed={'17s'}
            right={100}
            widthHeight={500}
            delay={'-8s'}
            backgroundColor={'#0887E0'}
            animations={{
              WebkitAnimation: 'move-up 15s linear infinite',
              MozAnimation: 'move-up 15s linear infinite',
              msAnimation: 'move-up 15s linear infinite',
              OAnimation: 'move-up 15s linear infinite',
              animation: 'move-up 15s linear infinite'
            }}
          />
          <Bubble
            speed={'8s'}
            right={150}
            widthHeight={500}
            delay={'-10s'}
            backgroundColor={'#93CCFD'}
            animations={{
              WebkitAnimation: 'move-up 15s linear infinite',
              MozAnimation: 'move-up 15s linear infinite',
              msAnimation: 'move-up 15s linear infinite',
              OAnimation: 'move-up 15s linear infinite',
              animation: 'move-up 15s linear infinite'
            }}
          />
          <Bubble
            speed={'17s'}
            right={200}
            widthHeight={300}
            delay={'-13s'}
            backgroundColor={'#50DCF6'}
            animations={{
              WebkitAnimation: 'move-up-right 15s linear infinite',
              MozAnimation: 'move-up-right 15s linear infinite',
              msAnimation: 'move-up-right 15s linear infinite',
              OAnimation: 'move-up-right 15s linear infinite',
              animation: 'move-up-right 15s linear infinite'
            }}
          />
          <Bubble
            speed={'17s'}
            right={100}
            widthHeight={200}
            delay={'-3s'}
            backgroundColor={'#4097F8'}
            animations={{
              WebkitAnimation: 'move-up-left 15s linear infinite',
              MozAnimation: 'move-up-left 15s linear infinite',
              msAnimation: 'move-up-left 15s linear infinite',
              OAnimation: 'move-up-left 15s linear infinite',
              animation: 'move-up-left 15s linear infinite'
            }}
          />
        </div>
        {/* <div className={'d-lg-none'}>
          <span className={'homepage topRight blue-15 twoThirds'} />
        </div> */}
        {moment().isBefore('2024-12-21') &&
          moment().isAfter('2024-11-01') && (
            <p style={{ fontSize: 22, marginTop: 20, fontWeight: 'bold' }}>
              Enjoy 10% off your study fees when enrolling on a course from now until 20th December 2024. Just quote WINTER24
            </p>
          )}
        {moment().isBefore('2024-08-30') &&
          moment().isAfter('2024-07-15') && (
            <p style={{ fontSize: 22, marginTop: 20, fontWeight: 'bold' }}>
              Quote SUMMER24 to receive 10% off course fees
            </p>
          )}
        {moment().isBefore('2020-12-22') &&
          moment().isAfter('2020-11-16') && (
            <p style={{ fontSize: 22, marginTop: 20, fontWeight: 'bold' }}>
              10% off all course fees* – quote WINTER20 (*excludes
              registration fees)
            </p>
          )}
        {moment().isBefore('2021-01-04') &&
          moment().isAfter('2020-12-22') && (
            <p style={{ fontSize: 22, marginTop: 20, fontWeight: 'bold' }}>
              We are closed from 23rd December 2020 till 4th January 2021
            </p>
          )}
        {moment().isBefore('2022-12-19') &&
          moment().isAfter('2022-11-22') && (
            <p style={{ fontSize: 22, marginTop: 20 }}>
              Quote <span style={{ fontWeight: 'bold' }}>Winter22</span> to
              receive 10% off course fees for enrolments completed before 19th
              December 2022
            </p>
          )}
      </PageHeader>
      <div className="page-section">
        <div className="container">
          <h3 className="section-title browse-courses-title">Browse Our Online Courses</h3>
          <p className='subheading-normal'>
          Improve your professional qualifications. 
          </p>
          <p className='subheading-bold'>
          Management, Leadership and Business online distance learning courses.
          </p>
        </div>
        <div className="course-buckets container">
          <div className="row">
            <Grid
              w="100%"
              templateColumns={[
                '1fr',
                '1fr 1fr',
                '1fr 1fr 1fr',
                '1fr 1fr 1fr'
              ]}>
              {!pricesLoaded ? (
                Array.from({ length: 7 }).map((_, i) => (
                  <CourseBucketSkeleton key={i} />
                ))
              ) : (
                <React.Fragment>
                  <CourseBucket
                    image="/images/courses/CMI.svg"
                    name="Online Management &amp; Leadership Courses"
                    link="/courses/management-leadership"
                    fromPrice={categoryMinPrices['management-leadership']}
                  />
                  <CourseBucket
                    image="/images/courses/CMI.svg"
                    name="Coaching & Mentoring Courses"
                    link="/courses/coaching-mentoring"
                    fromPrice={categoryMinPrices['coaching-mentoring']}
                  />
                  <CourseBucket
                    image="/images/courses/CMI.svg"
                    name="Professional Management Courses"
                    link="/courses/professional-management"
                    fromPrice={categoryMinPrices['professional-management']}
                  />
                  <CourseBucket
                    image="/images/logos/CMI_assessment_center.jpg"
                    name="Become a Chartered Manager"
                    link="/chartered-manager"
                  />
                  <CourseBucket
                    image="/images/courses/CMI.svg"
                    name="Professional Consultancy Courses"
                    link="/courses/professional-consultancy"
                    fromPrice={categoryMinPrices['professional-consultancy']}
                  />
                  <CourseBucket
                    image="/images/courses/CMI.svg"
                    name="Project Management Courses"
                    link="/courses/project-management"
                    fromPrice={categoryMinPrices['project-management']}
                  />
                  <CourseBucket
                    image="/images/courses/ELCAS.png"
                    name="ELCAS Learning Provider"
                    link="/elcas-scheme"
                  />
                </React.Fragment>
              )}
            </Grid>
          </div>
          <div className="button-container ">
            <a href="/courses">
              <Button
                width={190}
                height={40}
                btnColor="rgba(77, 199, 117, 1)"
                boxShadow="0 20px 24px 0 rgba(77,199,117,0.20)"
                textColor="white"
                fontSize={14}
                borderRadius= "20px"
                >
                SEE ALL COURSES
              </Button>
            </a>
          </div>
        </div>
        {/*<img*/}
        {/*src="/images/circles/leftLightBlue.svg"*/}
        {/*height={830}*/}
        {/*style={{ position: 'absolute', top: 0, left: 0, zIndex: -1 }}*/}
        {/*/>*/}
        <span className={'homepage left blue-15 clockwise-8'} />
      </div>

      <div className="page-section first-why">
        <div className="container">
          <h3 className="section-title" data-aos="fade-up">
            Why study with the Brighton School of Business and Management?
          </h3>
          <div className="row why-study">
            <div className="col-12 col-lg-5">
              <h5 className="section-heading">Study in your own time</h5>
              <p>Study in your own time and place, even whilst you work.</p>
              <h5 className="section-heading">Online materials</h5>
              <p>
                Learning materials are available online anytime through either
                Moodle, our Virtual Learning Environment (VLE), Management
                Direct (CMI courses)
              </p>
             
            </div>
            <div className="col-lg-1 d-none d-lg-block" />
            <div className="col-lg-6" data-aos="fade-up">


            <div className='circle-wrapper'>
              <img
                src="./images/why-study-1-circle.svg"
                alt="white circle background"
                className='circle-border'
              />
              <img
                src="./images/why-study-1.png"
                alt="Brighton woman at pc"
                className="circle-image-1"
              />
              </div>

            </div>
          </div>
        </div>

        {/*<img*/}
        {/*src="/images/circles/rightLightBlue.svg"*/}
        {/*height={880}*/}
        {/*style={{ position: 'absolute', top: 0, right: 0, zIndex: -1 }}*/}
        {/*/>*/}
        <span className={'homepage right blue-30 clockwise-8'} />
      </div>

      

      <div className="page-section second-why">
        <div className="container">
          <div className="row why-study">
            <div data-aos="fade-up" className="col d-none d-lg-block">
            <div className='circle-wrapper'>
              <img
                src="./images/why-study-2-circle.svg"
                alt="white circle background"
                className='circle-border-2'
              />
              <img
                src="./images/why-study-2.png"
                alt="Brighton woman at pc"
                className="circle-image-1"
              />
              </div>
            </div>
            <div className="col-lg-1 d-none d-lg-block" />
            <div className="col-12 col-lg-5 image-1-mobile">
            <h5 className="section-heading">Personal tutor</h5>
              <p>
                You will be supported by a personal tutor who will give you
                guidance about your course and assignments.
              </p>
              <h5 className="section-heading">Courses start every Monday</h5>
              <p>
                Our courses are taken via online distance learning so you can
                start your course immediately.
              </p>
            </div>
          </div>
        </div>
        </div>
        
        <div className="page-section first-why">
        <div className="container">
          <div className="row why-study">
            <div className="col-12 col-lg-5">
            <p className="section-heading">Save money</p>
              <p>
                With our courses you will save money on traditional college
                and university fees.
              </p>
              <p className="section-heading">Payment plans available</p>
              <p>Take advantage of our flexible payment plans.</p>
              <h5 className="section-heading">Accredited qualifications</h5>
              <p>
                Many of our courses lead to UK accredited qualifications that
                have the same status as those studied at a college or
                university.
              </p>
            </div>
            <div className="col-lg-1 d-none d-lg-block" />
            <div className="col-lg-6" data-aos="fade-up">
            <div className='frame'>
              <img
                src="./images/why-study-3.png"
                alt="Brighton womanman at laptop"
                className="img-fluid bubble-img"
                width="498px"
                height="331px"
              />
            </div>
            </div>
          </div>
        </div>

        <span className={'homepage right blue-30 clockwise-8'} />
      </div>

      <div className="page-section join-over">
        <div className="container">
          <div className="row why-study">
            <div data-aos="fade-up" className="col d-lg-block" >
              <img
                src="./images/8000.png"
                alt="8000 number icon"
                className="img-fluid bubble-img"
                style={{boxShadow: 'none'}}
              />
            </div>
            <div className="col-lg-1 d-none d-lg-block" />

            <div className="col-12 col-lg-5">
              <h3 className="section-heading successful-students-text" data-aos="fade-up" style={{marginTop: '2rem'}}>
                Successful Students
              </h3>
              <p>
                <strong>
                  Over 8000 students 
                  </strong>
                   &nbsp; have completed an online distance learning
                course through&nbsp;
                <strong>
                Brighton School of Business and Management
                </strong>
              </p>
            </div>
          </div>
        </div>
        </div>

      <div className="page-section q-and-a">
        <QandAHomepage />
        <div className="container button-container">
          <a href={'/faq'}>
            <Button
              width={190}
              height={60}
              btnColor="rgba(77, 199, 117, 1)"
              boxShadow="0 20px 24px 0 rgba(77,199,117,0.20)"
              textColor="white"
              fontSize={14}>
              SEE MORE
            </Button>
          </a>

        </div>
        <img
          src="/images/circles/testHome.svg"
          style={{ position: 'absolute', top: 0, left: '50%', zIndex: -1, height:"100%"}}
          alt="footer circle"
          // className='bubble-home'
        />
      </div>
      <div className="col text-center spacer-100" data-aos="fade-up"
         >
            <a
              className="cant-find-home-bold"
              href="/contact"
              >
              Can't find what you are looking for?{' '}
              
            </a>
            
            <p
              className='cant-find-home'
              style={{ fontSize: 40, color: "inherit"}}
              >
                <span className="cant-find-home-bold" 
                >Get in Touch </span>
              {/* Or give us a call on{' '} */}
              {/* <span style={{ fontWeight: 700 }}>+44 (0)1273 704 463</span> */}
            </p>
          </div>
          
                <ContactForm addSpaceAbove={true}/>
          
      <div className="col text-center popular-courses " data-aos="fade-up"
      style={{marginTop: "10rem"}}
      >
        <strong onClick={toggleAccordion}>
          Our Popular Online Business Courses
        </strong>{' '}
        <i className={accordionIsOpen ? 'arrow up' : 'arrow down'}></i>
        <Collapse isOpen={accordionIsOpen}>
          {seoCourses &&
            seoCourses.map(parent => (
              <div className="course-group" key={parent.slug}>
                <h2 className="popular-heading">
                  <a href={`/courses/${parent.slug}`}>{parent.name}</a>
                </h2>
                {parent.courses &&
                  parent.courses.map(course => (
                    <h2 className="popular-child" key={course.slug}>
                      <a href={`/courses/${parent.slug}/${course.slug}`}>
                        {course.name}
                      </a>
                    </h2>
                  ))}
              </div>
            ))}
        </Collapse>
      </div>
    </Page>
  );
};

const mapStateToProps = state => ({
  courses: state.courses.courses
});

export default connect(mapStateToProps)(Home);
